// export const BASE_URL = "http://192.168.0.24:8000/"
export const BASE_URL =
  // "https://www.backend.kadugudabba.com/"; //Live URL
  "https://uat-script.kadugudabba.com/"; //DEV URL
// "https://dev-script.kadugudabba.com/";
// "http://192.168.0.26:8000/";

export const URLS = {
  LOGIN: "admin/login/",
  LOGOUT: "admin/logout/",
  RESEND_OTP: "resend-otp",
  REGISTER_OTP_VERIFY: "verify-otp-and-register",
  STATES: "states",
  FORGOT_PASSWORD: "admin/forget-password/",
  RESET_PASSWORD: "admin/reset-password/",
  ADMINURL: "admin/",
  HELP_SUPPORT: "admin/help-support/",
  HELP_SUPPORT_REPLY: "admin/support/reply/",
  HELP_SUPPORT_VIEWED: "admin/help-support/viewed",
  USERROLEURL: "admin/role/",
  ABOUT_LIST: "admin/about-us/",
  ABOUT_EDIT: "admin/about-us/edit/",

  FAQ_LIST: "admin/faqs/",
  // FAQ_EDIT: "admin/faqs/edit/",
  NOTIFICATION_LIST: "admin/notifications_list/",
  DELIVERY_NOTIFICATION_LIST: "admin/delivery-partners/notifications_list/",
  PUSHNOTIFICATION: "admin/push-notifications/",
  DELIVERYPUSHNOTIFICATION: "admin/delivery-partners/push-notifications/",

  USERLIST_DROPDOWN: "admin/users-list/",

  USERLIST: "admin/users/",
  USER_STATUS: "admin/users/status-update/",

  ROLELIST: "admin/router/roles/",
  ADD_ROLE: "admin/role/",
  EDIT_ROLE: "admin/router/roles/",
  ROLE_STATUS: "admin/role/update-status/",
  ROLEPERMISSION: "admin/router/permissions/",

  FOOD_LIST: "admin/foods/list/",
  FOOD_VIEW: "admin/foods/detail/",
  BOOKING_LIST: "admin/bookings/list/",
  BOOKING_VIEW: "admin/bookings/detail/",
  TRANSACCTION_LIST: "admin/transactions-list/",
  BLOCKED_USERS_LIST: "admin/reports/",
  BLOCKED_USERS_ACTION: "admin/reports/action/",
  UNBLOCK_USERS_ACTION: "admin/users/unblock/",
  SUBSCRIPTIONLIST: "admin/subscription/list/",
  SUBSCRIPTIONCREATE: "admin/subscription/create/",
  SUBSCRIPTIONUPDATE: "admin/subscription/update/",
  SUBSCRIPTIONSTATUS: "admin/subscription/status-update/",
  SUBSCRIPTIONUSER: "admin/user/subcription/list/",
  USERS_ORDERS_LIST: "admin/user/orders/",
  USERS_ORDERS_WALLET: "admin/users/wallet-history/",

  //Dashboard
  DAHBOARD_CUSTOMERS: "admin/dashboard/customers/",
  DASHBOARD_SUBSCRIPTION: "admin/dashboard/subscription-amount/",
  DASHBOARD_TODAY_FOODS: "admin/dashboard/today-foods/",
  DASHBOARD_TODAY_SALES: "admin/dashboard/today-sales/",
  DASHBOARD_TOTAL_SALES: "/admin/dashboard/total-sales/",

  VERSION_LIST_GET: "master/settings/list/",
  VOW_VERSION_UPDATE: "master/settings/",

  MASTERLIST: "admin/master/list/",
  MASTER_UPDATE: "admin/master/update/",
  MASTERCREATE: "admin/master/create/",
  MASTERDELETE: "admin/master/delete/",
  MASTERsTATUS: "admin/master/status-update/",

  VIDEOLIST: "admin/video-master/list/",
  VIDEOCREATE: "admin/video-master/create/",
  VIDEOUPDATE: "admin/video-master/update/",
  VIDEOSTATUS: "admin/video-master/status-update/",
  VIDEODELETE: "admin/video-master/delete/",

  PROMOTION_BANNER_LIST: "admin/promo-popups/list/",
  PROMOTION_BANNER_CREATE: "admin/promo-popups/create/",
  PROMOTION_BANNER_UPDATE: "admin/promo-popups/update/",
  PROMOTION_BANNER_STATUS: "admin/promo-popups/status-update/",
  PROMOTION_BANNER_DELETE: "admin/promo-popups/delete/",

  USERADDRESS: "admin/location-storing/",
  USER_VERIFICATIONS: "admin/user-verifications/",

  PINCODELIST: "admin/pin-code/list/",
  PINCODEVIEW: "admin/pincode-list-by-date/",
  PINCODEUSER: "admin/pincode-user-list/",

  GETCONFIG: "admin/kd-settings-list/",
  POSTCONFIG: "admin/kd-setting/",
  DELIVERYPRICING: "admin/vehicle-charge-master/",
  DELIVERYPARTNER: "admin/delivery-partners/",
  DRIVERVERIFICATION: "admin/verifications/action/",

  GETDELIVERYPARTNERTABLE: "admin/delivery-partners/orderstatus/",
  GETDELIVERYPARTNERWALLET: "admin/delivery-partner/orders/wallet/",

  COMMISSION: "admin/commission/",

  USERWALLET: "admin/wallet/",

  WITHDRAWGET: "admin/withdraw-requests/",

  WITHDRAWVIEW: "admin/withdraw-requests/detail/",

  DELIVERYHELP: "admin/delivery-partners/help-support/",

  CLOSEDREQUSET: "admin/delivery-partners/unfulfilled-order/",
};
